import React from "react";
import AttachServiceProvider from "./AttachServiceProvider";

// On every plan a service provider is added in two steps: the person is created under Employees with the Crew role
// (which makes their login), then their services, fee and shifts are attached here. The old one-step wizard that
// created the login and the details together is retired, so there is a single place that decides a person's role.
// (The old wizard, AddProvider.jsx, is no longer routed.)
export default function AddProviderGate() {
  return <AttachServiceProvider />;
}
